import { Request } from '../';

/**
 * 钱包摘要
 * @param payload
 * @returns {*}
 */
export const walletUser = async payload => {
  const gql = `query walletUser {
  me {
    detail {
      createTime
      updateTime
      isAgent
      aliasName
    }
  }
}
`;
  return (await Request.request(gql, payload, 'wallet', '钱包摘要')).me.detail;
};

/**
 * 钱包类型
 * @param payload
 * @returns {*}
 */
export const walletAllow = async payload => {
  const gql = `query walletAllow {
  pub {
    categoryAllow
  }
}
`;
  return (await Request.request(gql, payload, 'wallet', '钱包类型')).pub.categoryAllow;
};

/**
 * 资金详情(所有钱包)
 * @param payload
 * @returns {*}
 */
export const walletList = async payload => {
  const gql = `query walletList($walletAllow: [String!]) {
  me {
    walletLis(cateLis: $walletAllow) {
      isActive
      updateTime
      status
      category
      currency
      amount
      balance
      freezing
      overdraft
      capacity
      commentJson
      comment
      roundInt
    }
  }
}
`;
  return (await Request.request(gql, payload, 'wallet', '资金详情')).me.walletLis;
};
